export default {
  access: state => state.access,
  agentAccess: state => state.agentAccess
};
